<!--
 * @Author: Ximen
 * @Date: 2021-03-23 19:40:08
 * @LastEditors: Ximen
 * @LastEditTime: 2021-04-06 17:10:46
-->
<template>
  <a-modal
  v-model:visible="visible" :footer="null" width="447px" @cancel="close()">
    <p class="title">明细</p>
    <a-table :columns="columns" :data-source="list" :pagination="false"/>
    <ul class="list-box">
      <li class="list">
        <div class="p1">
          小计：
        </div>
        <div class="p2">
          ￥ {{info.amount}}
        </div>
      </li>
      <li class="list">
        <div class="p1">
          优惠金额：
        </div>
        <div class="p2">
          ￥ {{info.discountAmount}}
        </div>
      </li>
      <li class="list">
        <div class="p1">
          实付金额：
        </div>
        <div class="p2" style="color:#FF0018">
          ￥ {{info.amount-info.discountAmount}}
        </div>
      </li>
    </ul>
    <a-button v-if="info.payStatus==0" type="primary"
    class="accept-btn" @click="payNow()">继续支付</a-button>
  </a-modal>
</template>

<script lang='ts'>
import { defineComponent } from 'vue';
import commonApi from '@/api/common';

const columns = [
  {
    title: '投标项目',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '周期',
    dataIndex: 'time',
    key: 'time',
  },
  {
    title: '金额',
    dataIndex: 'price',
    key: 'price',
  },
];
const list = [
  {
    key: '1',
    name: '电商独立版',
    time: '365天',
    price: '￥5,800.00',
  },
];
export default defineComponent({
  name: 'Detail',
  data() {
    return {
      visible: false,
      columns,
      list,
      info: {},
    };
  },
  components: {
  },
  methods: {
    showVisible(item: TObject) {
      console.log(item);
      this.getDetail(item);
    },
    getDetail(item: TObject) {
      interface Data{
        data: TString;
        success: boolean;
        message: string;
      }
      commonApi.getSaasUpgradePayDetail({
        siteId: item.siteId,
        rechargeNo: item.rechargeNo,
      }).then(async ({ data, success, message }: Data) => {
        if (success) {
          console.log(data);
          this.info = data;
          this.list[0] = {
            key: data.rechargeNo,
            name: data.versionName,
            time: `${data.cycle}天`,
            price: data.amount,
          };
          this.visible = true;
        } else {
          console.log(message);
        }
      });
    },
    close() {
      this.visible = false;
    },
    payNow() {
      const parent = this.$parent as unknown as {[x: string]: Function};
      parent.handleToPay(this.info);
      this.close();
    },
  },
});
</script>
<style lang="stylus" scoped>
  .title
    font-size 24px
    color #073D7D
    text-align center
    margin-bottom 26px
  .list-box
    list-style-type none
    margin 0
    margin-top 20px
    padding 0
    .list
      display flex
      flex-direction row
      justify-content space-between
      padding 2px 0
      .left-box
        p
          margin 0
        .p1
          font-size 14px
          color #333
        .p2
          font-size 14px
          color #333
      .right-box
        p
          margin 0
        .p1
          font-size 14px
          color #333
        .p2
          font-size 14px
          color #333
  .accept-btn
    width 100%
    height 50px
    font-size 16px
    margin-top 22px
    border-radius 5px
    background #3281dd
    color #fff
    border none
</style>
